import React from 'react';

const getEspecialidadeLabel = (especialidade) => {
  if (especialidade === 'casas') return 'Imóveis';
  if (especialidade === 'carros') return 'Veículos';
  return 'Reformas';
};

export const VendedorProfileCard = ({ vendedor }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-8" data-testid="vendedor-profile-card">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 h-32" data-testid="vendedor-profile-banner"></div>

      <div className="px-6 pb-6 -mt-16">
        <div className="flex flex-col sm:flex-row items-center sm:items-end gap-4">
          <div className="w-32 h-32 bg-white rounded-full border-4 border-white shadow-lg overflow-hidden flex items-center justify-center" data-testid="vendedor-avatar-container">
            {vendedor.foto_url ? (
              <img src={vendedor.foto_url} alt={vendedor.nome} className="w-full h-full object-cover" data-testid="vendedor-avatar-image" />
            ) : (
              <span className="text-5xl" data-testid="vendedor-avatar-placeholder">👤</span>
            )}
          </div>

          <div className="text-center sm:text-left pb-2">
            <h1 className="text-2xl font-bold text-gray-900" data-testid="vendedor-name">{vendedor.nome}</h1>
            <p className="text-gray-600" data-testid="vendedor-title">Consultor RH Holdings</p>

            {vendedor.especialidade && vendedor.especialidade !== 'todos' && (
              <span className="inline-block mt-2 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm" data-testid="vendedor-specialty-badge">
                Especialista em {getEspecialidadeLabel(vendedor.especialidade)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
